export default __webpack_public_path__ + "assets/MyAccess_2.png";